<template>
  <v-app class="entrada-salida">
    <header class="pl-13 v-app-bar" style="background: #fff;">
      <div class="v-toolbar__content" style="height: 56px;">
        <div elevation="0" class="pl-0 header-icon">
          <v-icon class="icon caja-out"></v-icon>
        </div>
      </div>
    </header>
    <Menu />
     
    <v-main class="background">

      <div class="mx-auto my-auto">
          <router-link class="mx-auto d-flex" :to="{ name: 'Albaranes', query: { modo: 'entrada' } }" v-if="permitido('MOBILESTORE.PHONESERVICES.ENTRADAS.ALBARANES')"> 
            <v-btn large class="primary "
            >
              <v-icon class="mr-3 ">mdi-file-document-outline</v-icon>
              Entrada por ODT / Albaran
            </v-btn>
          </router-link>

          <router-link class="d-flex  mt-6" :to="{ name: 'Bultos'}" v-if="permitido('MOBILESTORE.PHONESERVICES.ENTRADAS.BULTOS')"> 
            <v-btn large
            class="primary col-12"
            >
            <v-icon class="mr-3 ">mdi-archive-settings</v-icon>
              Entrada por bulto / SSCC
            </v-btn>
          </router-link>

          <router-link class="d-flex  mt-6" :to="{ name: 'EntradaManual'}" v-if="permitido('MOBILESTORE.PHONESERVICES.ENTRADAS.MANUAL')"> 
            <v-btn large
            class="primary col-12"
            >
            <v-icon class="mr-3 ">mdi-archive-outline</v-icon>
              Entrada manual
            </v-btn>
          </router-link>
     </div>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import Menu from '../../components/Menu.vue';

export default Vue.extend({
  name: 'Profile',
  components: {
    Menu
  },
  data: () => ({
    codOdt: ''
  }),
  beforeCreate () {
    this.$root.$emit('verificarCertificado', location.href)
  },
  mounted() {
    
  },
  methods: {
  },
});
</script>
